module.exports = __webpack_public_path__ + "img/dHsEhcSK.f429ba23.svg";